try{self['workbox:expiration:4.3.1']&&_()}catch(e){}// eslint-disable-line